import { generateStreamCIDKey } from '../components/Streams/utils/generateStreamCIDKey';

export const mergeStreamWithUserData = (
  { data: { id, ...backendStream } },
  { data: userData },
) => ({
  ...backendStream,
  id: generateStreamCIDKey(backendStream),
  streamId: id,
  userData,
  isFollow: !userData?.userRoleMapping.roles.length,
});

export const mergeStreamsListWithUserData = (
  { data: streamsList },
  { data: userDataMap },
) => ({
  streams: streamsList.map(stream =>
    mergeStreamWithUserData(
      { data: stream },
      { data: userDataMap[generateStreamCIDKey(stream)] },
    ),
  ),
});
